// SP4 — mobile navigation drawer: a left slide-over (Radix Dialog) hosting the
// shared SidebarNav on small screens, toggled by the topbar hamburger. The
// desktop sidebar is hidden below `md`; this replaces it there. Closes on a
// nav-link click (onNavigate), Esc, or overlay click (Radix Dialog built-ins).
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { SidebarNav } from '@/components/sidebar';
import { Logo } from '@/components/logo';

export interface MobileNavDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function MobileNavDrawer({ open, onOpenChange }: MobileNavDrawerProps): JSX.Element {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-foreground/40 backdrop-blur-sm md:hidden data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-0" />
        <DialogPrimitive.Content
          data-testid="mobile-nav-drawer"
          className="fixed inset-y-0 left-0 z-50 flex w-64 flex-col bg-[hsl(var(--sidebar))] text-[hsl(var(--sidebar-foreground))] shadow-xl outline-none md:hidden data-[state=open]:animate-in data-[state=open]:slide-in-from-left data-[state=closed]:animate-out data-[state=closed]:slide-out-to-left"
        >
          <DialogPrimitive.Title className="sr-only">Navigation</DialogPrimitive.Title>
          <div className="flex h-14 shrink-0 items-center border-b border-white/10 px-3">
            <Logo collapsed={false} />
          </div>
          <div className="flex-1 overflow-y-auto p-3">
            <SidebarNav collapsed={false} onNavigate={() => onOpenChange(false)} />
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}

export default MobileNavDrawer;
